import { Breadcrumb } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-layout/models/breadcrumb.model';

export const PasosBreadcrumb: Breadcrumb[] = [
  {
    numeroPaso: 1,
    nombre: 'Cotización',
  },
  {
    numeroPaso: 2,
    nombre: 'Datos',
  },
  {
    numeroPaso: 3,
    nombre: 'Pago',
  },
];
